namespace Cfnc {
    "use strict";

    export interface IexclusiveLoginScope extends ng.IScope {
        exLoginForm: ng.IFormController;
    }

    interface IexclusiveLogin {
        activate: () => void;
        logoPath: string;
        appName: string;
        appDefId: string;
        organization: string;
        program: string;
        appKey: string;
        busy: boolean;
        loading: boolean;
        loginInfo: ILoginBindingModel;
        errors: Array<any>;
    }

    class exclusiveLogin implements IexclusiveLogin {
        static controllerId: string = "exclusiveLogin";

        static $inject: string[] = ["$scope", "$location", "$rootScope", "config", "$routeParams", "common", "Restangular"];
        logoPath: string;
        appName: string;
        appDefId: string;
        organization: string;
        program: string;
        appKey: string;
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        busy: boolean = false;
        loading: boolean = true;
        loginInfo: ILoginBindingModel;
        errors: Array<any> = [];

        constructor(private $scope: ng.IScope, private $location: ng.ILocationService, private $rootScope: IApplicationRootScope, private config: Config, private $routeParams, private common: ICommonFactory, private Restangular: Restangular.IService) {
            this.$rootScope.stylesheets = [];
            this.log = common.logger.getLogFn(exclusiveLogin.controllerId);
            this.logError = common.logger.getLogFn(exclusiveLogin.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(exclusiveLogin.controllerId, "success");
            var baseStyleSheet = {
                link: "/content/application.css"
            };

            this.$rootScope.stylesheets.push(baseStyleSheet);

            this.organization = this.$routeParams["organization"];
            this.program = $routeParams["program"];
            this.appKey = $routeParams["appKey"];
            let appdefId = `application/${this.organization}/${this.program}/${this.appKey}`;

            window.location.href = `${this.config.crossroadsUrl}/${appdefId}?logoUrl=${this.config.crossroadsApiUrl}/${appdefId}/exclusiveLogo`;

            //this.common.authentication.safeAccessToken().then((accessToken) => {
            //    if (accessToken) {
            //        window.location.href = this.config.crossroadsUrl + "/application/" + this.organization + "/" + this.program + "/" + this.appKey;
            //    }
            //});

            //this.activate();
        }

        activate() {

            var promises = [];
            this.common.activateController(promises, exclusiveLogin.controllerId)
                .then(() => {
                    this.log("Activated CreateAccount View");
                    this.Restangular.one("application/" + this.organization + "/" + this.program + "/" + this.appKey).get()
                        .then((result) => {
                            this.appName = result.name;
                            this.appDefId = result.applicationDefinitionId;

                            if (this.appDefId) {
                                this.appDefId = decodeURIComponent(this.appDefId);

                                this.logoPath = this.config.crossroadsApiUrl + "/application/" + this.appDefId + "/exclusiveLogo";

                                var appStyleSheet = {
                                    link: this.config.crossroadsApiUrl + "/application/" + this.appDefId + "/stylesheet"
                                };
                                this.$rootScope.stylesheets.push(appStyleSheet);
                            }
                            this.loading = false;
                        }, (reason) => {
                            console.log(reason);
                        });
                });

        }
    }

    angular.module("app").controller("exclusiveLogin", exclusiveLogin);
}